/**
 * Breadcrumb.jsx
 * Created by michaelbray on 2/23/18.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { toTitleCase } from '../../helpers/stringHelper';

const propTypes = {
    campground: PropTypes.object,
    campsite: PropTypes.object,
    isCampgroundPage: PropTypes.bool,
    isCampsitePage: PropTypes.bool,
    isAvailableCampgroundDateRangePage: PropTypes.bool,
    recarea: PropTypes.object,
    className: PropTypes.string
};

class Breadcrumb extends React.Component {
    render() {
        const recarea = this.props.recarea.results;
        const campground = this.props.campground.results;
        const campsite = this.props.campsite.results;
        return (
            <nav className={this.props.className} role="navigation">
                <ul className="rec-breadcrumb">
                    <li>
                        <Link id="home-link" to="/">Home</Link>
                    </li>

                    {recarea.name &&
                    <li>
                        <Link id="gateway-link" to={`/gateways/${recarea.id}`}>
                            {recarea.name}
                        </Link>
                    </li>
                    }
                    <li>
                        {!this.props.isCampgroundPage &&
                        <Link id="campground-link" to={`/campgrounds/${campground.facility_id}`}>
                            {toTitleCase(campground.facility_name)}
                        </Link>
                        }
                        {this.props.isCampgroundPage &&
                        toTitleCase(campground.facility_name)
                        }
                    </li>

                    {this.props.isAvailableCampgroundDateRangePage &&
                    <li id="campground-availability-path">
                        Date Range Availability
                    </li>
                    }

                    {this.props.isCampsitePage &&
                    <li id="campsite-path">
                        {`Site ${campsite.campsite_name}`}
                    </li>
                    }
                </ul>
            </nav>
        );
    }
}

Breadcrumb.propTypes = propTypes;

function select(state) {
    return {
        search: state.search,
        searchResults: state.searchResults,
        recarea: state.recarea,
        campground: state.campground,
        campsite: state.campsite
    };
}

export default connect(select)(Breadcrumb);
